import { memo } from 'react';

const Loader = memo(
  /**@param {LoaderProps} LoaderProps is an object to control the loader behavior*/
  ({ visibility = false, type }) => {
    return (
      <div className={visibility ? 'lds-ripple pagination' : 'lds-ripple pagination hide'}>
        <div></div>
        <div></div>
      </div>
    );
  },
);

export default Loader;

/**
 * Options for Loader component
 * @typedef LoaderProps
 * @type {object}
 * @property {boolean} [visibility]
 * If `true` the loader will be shown
 * @property {'pagination'|null} [type]
 * If this prop is "pagination", then the loader will be shown as a component that could be putted into any container (for example a div).
 *
 * Will be used ONLY if the prop `type` is `"pagination"`
 */
